"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomerPointsContract = void 0;
const contract_1 = require("../base/contract");
const points_schemas_1 = require("../../schemas/customer/points.schemas");
const api_schemas_1 = require("../../schemas/base/api.schemas");
/**
 * Customer Points Contract
 *
 * PRD Note: Points are "pending" vs "available" (FR76).
 * V1: Commission is immediate (pending always 0). V2: Pending becomes available after 3 hours (FR81).
 * Points are merchant-specific, not transferable (FR162).
 */
exports.CustomerPointsContract = (0, contract_1.createContract)({
    serviceModule: 'user',
    name: 'CustomerPoints',
    baseUrl: '/points',
    version: '1',
    endpoints: {
        listPoints: {
            method: 'GET',
            path: '/',
            body: null,
            query: points_schemas_1.listPointsQuerySchema,
            params: null,
            headers: null,
            response: {
                success: points_schemas_1.listPointsResponseSchema,
                errors: {
                    unauthorized: api_schemas_1.baseErrorResponseSchema,
                },
            },
            middleware: ['auth:required'],
            documentation: {
                summary: 'List points by merchant',
                description: 'Retrieves points balances across all merchants the user has earned from, optionally filtered by merchant',
                tags: ['Customer', 'Points'],
                deprecated: false,
            },
            tests: [
                'should return points for all merchants',
                'should filter by merchantId',
                'should return empty list for user with no points',
            ],
        },
        getMerchantPoints: {
            method: 'GET',
            path: '/:merchantId',
            body: null,
            query: null,
            params: points_schemas_1.getMerchantPointsParamsSchema,
            headers: null,
            response: {
                success: points_schemas_1.getMerchantPointsResponseSchema,
                errors: {
                    unauthorized: api_schemas_1.baseErrorResponseSchema,
                    notFound: api_schemas_1.baseErrorResponseSchema, // No points record for this merchant
                },
            },
            middleware: ['auth:required'],
            documentation: {
                summary: 'Get points for a merchant',
                description: 'Retrieves points balance (available and pending) for a specific merchant',
                tags: ['Customer', 'Points'],
                deprecated: false,
            },
            tests: [
                'should return merchant points with available and pending',
                'should return 404 for merchant with no points record',
            ],
        },
        getMerchantPointsHistory: {
            method: 'GET',
            path: '/:merchantId/history',
            body: null,
            query: points_schemas_1.getMerchantPointsHistoryQuerySchema,
            params: points_schemas_1.getMerchantPointsHistoryParamsSchema,
            headers: null,
            response: {
                success: points_schemas_1.getMerchantPointsHistoryResponseSchema,
                errors: {
                    unauthorized: api_schemas_1.baseErrorResponseSchema,
                    notFound: api_schemas_1.baseErrorResponseSchema,
                },
            },
            middleware: ['auth:required'],
            documentation: {
                summary: 'Get points history for a merchant',
                description: 'Retrieves paginated history of points transactions (earned, redeemed, cancelled, adjustment) for a specific merchant',
                tags: ['Customer', 'Points'],
                deprecated: false,
            },
            tests: [
                'should return paginated points history',
                'should include earned, redeemed, cancelled transaction types',
                'should return 404 for merchant with no history',
            ],
        },
    },
});
